import type { CalendarState } from '@react-stately/calendar';
import { useMemo } from 'react';

import { useDatePickerConfig } from '../../contexts/ConfigContext';
import { isYearDisabled } from '../../utils';
import { GridPicker } from '../GridPicker';

interface YearPickerProps {
  state: CalendarState;
  onYearSelect: (year: number) => void;
}

export function YearView({ state, onYearSelect }: YearPickerProps) {
  const { disablePresets } = useDatePickerConfig();
  const currentYear = state.focusedDate.year;
  const startYear = currentYear - 6;
  const years = useMemo(() => Array.from({ length: 12 }, (_, i) => startYear + i), [startYear]);

  const checkYearDisabled = useMemo(
    () => (year: number) => isYearDisabled(year, state, disablePresets),
    [state, disablePresets],
  );

  return (
    <GridPicker
      items={years}
      selectedValue={state.value?.year ? state.value.year : undefined}
      focusedValue={currentYear}
      onSelect={onYearSelect}
      renderItem={(year) => year}
      dataAttribute="data-year"
      wrap={false}
      ariaLabel="Select year"
      isItemDisabled={checkYearDisabled}
    />
  );
}
